import { Box, Grid, Link } from '@chronosphereio/chrono-ui';
import { ResponsiveWrapper } from '@/components';
import {
  PanelGroupItemId,
  PanelGroupSplitPanelDefinition,
  SplitVariableIterator,
  usePanelGroupActions,
} from '@/dashboards/context';
import { PanelOptions } from '../Panel';
import { GridItemContent } from './GridItemContent';

type SplitPanelContentProps = {
  definition: PanelGroupSplitPanelDefinition;
  panelGroupItemId: PanelGroupItemId;
  panelOptions?: PanelOptions;
};

export function SplitPanelContent(props: SplitPanelContentProps) {
  const { definition, panelGroupItemId, panelOptions } = props;
  const { openEditPanelGroup } = usePanelGroupActions(panelGroupItemId.panelGroupId);

  return (
    <Grid container spacing={1}>
      {!definition.splitVariableName && (
        <Box p={2}>
          To view panels, you must <Link onClick={openEditPanelGroup}>configure</Link> a variable to split the panel by.
          This will create a panel for each variable value that is selected.
        </Box>
      )}
      {definition.splitVariableName && (
        <SplitVariableIterator
          variableName={definition.splitVariableName}
          renderItem={(variableValue, { totalSelected }) => {
            const gridSize = { xs: 12, sm: 6, md: 6, lg: 6 };
            if (totalSelected === 3) {
              gridSize.md = 4;
              gridSize.lg = 4;
            } else if (totalSelected > 3) {
              gridSize.md = 4;
              gridSize.lg = 3;
            }

            return (
              <Grid item {...gridSize}>
                <div style={{ height: 250 }}>
                  <ResponsiveWrapper>
                    {({ width, height }) => {
                      return (
                        <GridItemContent
                          PanelProps={{
                            renderTitle: (title) => `${variableValue} - ${title}`,
                          }}
                          panelOptions={panelOptions}
                          panelGroupItemId={panelGroupItemId}
                          width={width}
                          height={height}
                          splitVariableValue={variableValue}
                        />
                      );
                    }}
                  </ResponsiveWrapper>
                </div>
              </Grid>
            );
          }}
        />
      )}
    </Grid>
  );
}
